<template>
    <div>
        <form @submit.prevent="handleSubmit()">
            <!--  -->
            <div
                :class="
                    `form-group row ${
                        report_errors.form_id &&
                        report_errors.form_id.length > 0 == true
                            ? 'has-error'
                            : ''
                    }`
                "
            >
                <label
                    class="col-md-2 col-form-label md:tw-text-right tw-text-left"
                >
                    เลือกฟอร์ม <span class="request-alert"></span>
                </label>
                <div class="col-md-4">
                    <select
                        name="form_id"
                        class="form-control"
                        @change="selectedForm()"
                        v-model="form.form_id"
                    >
                        <option value="">--- เลือกฟอร์ม ---</option>
                        <option
                            v-for="(form, index) in forms_data"
                            :key="index"
                            :value="form.id"
                        >
                            {{ form.title }}
                        </option>
                    </select>
                    <span
                        v-if="
                            report_errors.form_id &&
                                report_errors.form_id.length > 0 == true
                        "
                        class="help-block-alert"
                    >
                        กรุณาเลือกฟอร์ม
                    </span>
                </div>
            </div>

            <div class="form-group row">
                <label
                    class="col-md-2 col-form-label md:tw-text-right tw-text-left"
                >
                    เลือก Sale Page
                </label>
                <div class="col-md-4">
                    <select
                        name="salepage_id"
                        class="form-control"
                        v-model="form.salepage_id"
                    >
                        <option value="">--- เลือก sale page ---</option>
                        <option
                            v-for="(salepage, index) in salepages_data"
                            :key="index"
                            :value="salepage.id"
                        >
                            {{ salepage.title }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="row form-group">
                <label class="col-md-2 col-form-label"></label>
                <div class="col-10 offset-col-2">
                    <button class="btn btn-sm btn-success px-3">ตกลง</button>
                    <span @click="clearForm" class="btn btn-sm btn-link"
                        >ล้างข้อมูล
                    </span>
                </div>
            </div>
        </form>
        <div
            class="table-responsive tw-mt-10 report_table"
            v-if="data_table.bodies.length > 0 || data_table.data.length > 0"
        >
            <table class="table table-hover mb-0 c_list">
                <thead>
                    <tr>
                        <th
                            v-for="(body, index) in data_table.bodies"
                            :key="index"
                        >
                            {{ body.input }}
                        </th>
                        <th>Sale page</th>
                        <th>ฟอร์ม</th>
                        <th>UTM</th>
                        <th>วันที่</th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-if="
                            data_table.bodies.length != 0 &&
                                data_table.data.length <= 0
                        "
                    >
                        <td
                            class="text-center"
                            :colspan="data_table.bodies.length + 3"
                        >
                            ไม่พบข้อมูล
                        </td>
                    </tr>
                    <tr
                        v-else
                        v-for="(item, index) in data_table.data"
                        :key="index"
                    >
                        <template
                            v-for="(inputItem, inputIndex) in data_table.bodies"
                        >
                            <td :key="`${inputIndex}`">
                                {{ item.input[inputItem.input] || "-" }}
                            </td>
                        </template>

                        <td>
                            {{ item.sale_pages.title }}
                        </td>
                        <td>
                            {{ item.forms.title }}
                        </td>
                        <td>
                            <div
                                v-for="(utm, utmKey) in item.utm"
                                :key="utmKey"
                            >
                                {{ `${utmKey}: ${item.utm[utmKey]} ` }}
                            </div>
                        </td>
                        <td>
                            {{ dateFormat(item.created_at) }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
import moment from "moment";
export default {
    props: {
        shop: {
            required: true
        },
        salepages: {
            required: true
        },
        forms: {
            required: true
        },
        action_url: {
            required: false
        },
        report_errors: {
            required: false
        }
    },
    data() {
        return {
            form: {
                form_id: "",
                salepage_id: ""
            },
            salepages_data: this.salepages,
            forms_data: this.forms,
            data_table: {
                data: [],
                bodies: []
            }
        };
    },
    mounted() {
        this.setFormId();
    },
    methods: {
        setFormId(){
            const { form_id } = this.getQuery()
            this.form.form_id = form_id
        },
        getQuery() {
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            return params;
        },
        clearForm() {
            this.form = {
                form_id: "",
                salepage_id: ""
            };
        },
        dateFormat(date) {
            return moment(date).format("DD/MM/YYYY, h:mm:ss a") || "";
        },
        selectedForm() {
            axios
                .get(
                    `/backend/s/${this.shop}/report-forms/filter-salepage/${this.form.form_id}`
                )
                .then(res => {
                    this.salepages_data = res.data.salepages;
                });
        },
        getDataTable() {
            axios
                .post(
                    `/backend/s/${this.shop}/report-forms/datatable`,
                    this.form
                )
                .then(res => {
                    this.data_table.bodies = res.data.formformBodies;
                    this.data_table.data = res.data.reportForm;
                });
        },
        handleSubmit() {
            this.getDataTable();
            this.post(this.action_url, this.form, "get");
        },
        post(path, params, method = "post") {
            const form = document.createElement("form");
            form.method = method;
            form.action = path;

            for (const key in params) {
                if (params.hasOwnProperty(key)) {
                    const hiddenField = document.createElement("input");
                    hiddenField.type = "hidden";
                    hiddenField.name = key;
                    hiddenField.value = params[key];

                    form.appendChild(hiddenField);
                }
            }

            document.body.appendChild(form);
            form.submit();
        }
    }
};
</script>
<style lang="scss">
.report_table {
    height: 500px;
}
</style>
